import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { type Address } from "viem";

import { addressStorage } from "#/config/jotai";

export const mirrorAccountAtom = atomWithStorage<Address | undefined>(
  "MIRROR_ACCOUNT",
  undefined,
  addressStorage,
);

export const useMirrorAccount = () => {
  const [mirrorAccount, setMirrorAccount] = useAtom(mirrorAccountAtom);

  return {
    mirrorAccount,
    setMirrorAccount,
  };
};
